var mobileNavButton = document.getElementById("mobileNavButton");
var siteHeaderNav = document.getElementById("siteHeaderNav");
var panelTriggers = document.querySelectorAll(".header-nav__panel--trigger");
var panelOverlay = document.querySelector(".header-nav--overlay");

// mobile menu show/hide
mobileNavButton.addEventListener("click", function() {
  var isActive = this.classList.contains("active") && siteHeaderNav.classList.contains("active");

  if (!isActive)
  {
    this.classList.add("active");
    this.setAttribute("aria-expanded", "true");
    siteHeaderNav.classList.add("active");
    panelOverlay.classList.add("active");
  }
  else
  {
    this.classList.remove("active");
    this.setAttribute("aria-expanded", "false");
    siteHeaderNav.classList.remove("active");
    panelOverlay.classList.remove("active");
  }
});

// sub menu (panels) show/hide
panelTriggers.forEach(function(trigger) {
  trigger.addEventListener("click", function() {
    menuPanel(this);
  });
});

// when press menu bar item
panelTriggers.forEach(function(trigger) {
  trigger.addEventListener("keydown", function(e) {
    var code = e.keyCode || e.which;
    // Enter or space or down
    if (code == 13 || code == 32 || code == 40)
    {
      menuPanel(this);
    }
    // shift key and tab or space or down
    else if ((e.shiftKey) && (code == 9 || code == 32 || code == 40))
    {
      menuPanelClose(this);
    }
  });
});

// when shift-press the first menu item in menu panel
document.querySelectorAll(".header-nav__main:first-child > a").forEach(function(link) {
  link.addEventListener("keydown", function(e) {
    var code = e.keyCode || e.which;
    var itsTrigger = this.closest(".header-nav__panel").previousElementSibling;

    // shift key and tab or space or down
    if ((e.shiftKey) && (code == 9 || code == 32 || code == 40))
    {
      menuPanelClose(itsTrigger);
    }
  });
});

// when press the last menu item in menu panel
document.querySelectorAll(".header-nav__panel li:last-child > a, .header-nav__main:last-child > a").forEach(function(link) {
  link.addEventListener("keydown", function(e) {
    var code = e.keyCode || e.which;
    var itsTrigger = this.closest(".header-nav__panel").previousElementSibling;

    // no shift key but tab or space or down
    if ((!e.shiftKey) && (code == 9 || code == 32 || code == 40))
    {
      menuPanelClose(itsTrigger);
    }
  });
});

// close all menus on overlay click
panelOverlay.addEventListener("click", function() {
  mobileNavButton.classList.remove("active");
  siteHeaderNav.classList.remove("active");
  panelTriggers.forEach(function(trigger) {
    trigger.classList.remove("active");
  });
  document.querySelectorAll(".header-nav__panel").forEach(function(panel) {
    panel.classList.remove("active");
  });
  this.classList.remove("active");
});

function menuPanel(el) {
  var isActive = el.classList.contains("active");

  // open/close panel
  if (!isActive)
  {
    menuPanelOpen(el);
  }
  else
  {
    menuPanelClose(el);
  }

  // close siblings
  menuSiblingsClose(el);
}

function menuPanelOpen(el) {
  var itsPanel = el.nextElementSibling;

  el.classList.add("active");
  el.setAttribute("aria-expanded", "true");
  itsPanel.classList.add("active");
  itsPanel.querySelectorAll("a").forEach(function(a) { a.setAttribute("tabindex", 0); });
  // add overlay
  panelOverlay.classList.add("active");
}

function menuPanelClose(el) {
  var itsPanel = el.nextElementSibling;

  el.classList.remove("active");
  el.setAttribute("aria-expanded", "false");
  itsPanel.classList.remove("active");
  itsPanel.querySelectorAll("a").forEach(function(a) { a.setAttribute("tabindex", -1); });
  // remove overlay
  panelOverlay.classList.remove("active");
}

function menuSiblingsClose(el) {
  var siblingLis = el.parentElement.parentElement.children;
  for (var i = 0; i < siblingLis.length; i++) {
    var siblingTrigger = siblingLis[i].querySelector(".header-nav__panel--trigger");
    if (siblingTrigger && siblingTrigger !== el) {
      var siblingPanel = siblingTrigger.nextElementSibling;
      siblingTrigger.classList.remove("active");
      if (siblingPanel) {
        siblingPanel.classList.remove("active");
        siblingPanel.querySelectorAll("a").forEach(function(a) { a.setAttribute("tabindex", -1); });
      }
    }
  }
}
